<template>
  <div id="uncombat_unknockout">uncombat_unknockout</div>
</template>

<script>
export default {
  name: 'uncombat_unknockout',
  props: {
    datas: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
#uncombat_unknockout {
}
</style>
